<div class="modal-root">
  <header class="modal-header">
    <span> Equipment {{ data.equipment }}</span>
    <button class="close" (click)="close()">✕</button>
  </header>
  <section class="modal-body">
    <p><strong>Equipment Type:</strong> {{ data.equipmentType }}</p>
    <p><strong>Serial Number:</strong> {{ data.serialNumber }}</p>
    <mat-divider></mat-divider>

    <div class="modes modal-modes">
      @for (fm of data.reportAnalyses; track fm.name) {
      <div class="mode" [ngClass]="fm.status">
        <span class="icon">
          @if (fm.status === 'ok') {
          <img src="assets/icons/16px_check.svg" style="margin-right: 10px;">
          }
          @else if (fm.status === 'warning') {
          <img src="assets/icons/16px_warning-sign.svg" style="margin-right: 10px;">
          }
          @else if (fm.status === 'nodata') {
          <img src="assets/icons/24px_close.svg" style="margin-right: 10px; width: 60%;">
          }
        </span>
        <span class="label">{{ fm.name }}</span>
      </div>
      }
    </div>
    <div class="messages">
      @for (fm of data.reportAnalyses; track fm.name) {
      @if (fm.message){
      <div style="margin-bottom: 16px;">
        <strong>{{fm.name}}:</strong>
        <div [innerHTML]="fm.message | replace:'\n':'<br>'"></div>
      </div>
      }
      }

      @if (allModesOk) {
      <span>No issues found in the period.</span>
      }

    </div>
  </section>
  <footer class="modal-footer">
    <button mat-button (click)="close()">Close</button>
  </footer>
</div>
